import { getSupabaseClient } from '../../../../core/supabase/client.js';

export class ExportAccessRemoteDataSource {
  private get supabase() { return getSupabaseClient() as any; }

  async listExportViews() {
    const { data, error } = await this.supabase
      .from('export_views')
      .select('export_key, view_name, description')
      .order('export_key');
    if (error) throw new Error(error.message);
    return data ?? [];
  }

  async listGrants() {
    const { data, error } = await this.supabase
      .from('export_download_grants')
      .select('org_id, export_key, created_at, org:orgs(name)')
      .order('created_at', { ascending: false });
    if (error) throw new Error(error.message);
    return data ?? [];
  }

  async createGrant(orgId: string, exportKey: string) {
    const { error } = await this.supabase
      .from('export_download_grants')
      .insert({ org_id: orgId, export_key: exportKey });
    if (error) throw new Error(error.message);
  }

  async deleteGrant(orgId: string, exportKey: string) {
    const { error } = await this.supabase
      .from('export_download_grants')
      .delete()
      .eq('org_id', orgId)
      .eq('export_key', exportKey);
    if (error) throw new Error(error.message);
  }
}
